import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getApplicantId: {
        method: 'GET',
        url: `${BASE_PATH_API}/backgroundChecks/:id/applicant`
    },
    getBuildingsEligibleForTenantScreening: {
        method: 'GET',
        url: `${BASE_PATH_API}/backgroundChecks/properties`
    },
    getAccountEligibleForBackgroundChecks: {
        method: 'GET',
        url: `${BASE_PATH_API}/backgroundChecks/accountEligibility`
    },
    isUnitAddressValid: {
        method: 'GET',
        url: `${BASE_PATH_API}/backgroundChecks/validateUnitAddress`
    },
    validateEmail: {
        method: 'POST',
        url: `${BASE_PATH_API}/backgroundChecks/validateEmail`
    },
    createBackgroundCheck: {
        method: 'POST',
        url: `${BASE_PATH_API}/backgroundChecks`
    },
    createCosignerBackgroundCheck: {
        method: 'POST',
        url: `${BASE_PATH_API}/backgroundChecks/cosigner/:cosignerApplicantId`
    },
    validateScreeningOrderProperty: {
        method: 'POST',
        url: `${BASE_PATH_API}/backgroundChecks/validateScreeningOrderProperty`
    }
};

export function BackgroundChecksApi() {
    return createActions(actions);
}
